import { useTranslation } from "react-i18next";
import { MaxWidthContainer } from "../../../generic/layout/maxWidthContainer";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  GridItem,
  HStack,
  Text,
  UnorderedList,
  ListItem,
  VStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  SimpleGrid,
} from "@chakra-ui/react";
import WajmaMangalImage from "../../team/media/dr-wajma-mangal.jpg";
import { Link } from "react-router-dom";
import { FaSpotify } from "react-icons/fa6";
import { HeadingMedium } from "../../../generic/layout/headingMedium";
import { BiConversation } from "react-icons/bi";
import { LuPodcast } from "react-icons/lu";
import { TbMicrophone } from "react-icons/tb";

export function UnpluggedLandingComponent() {
  //get current language and load content accordingly
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <MaxWidthContainer>
      <HeadingMedium mb={6}>
        <HStack>
          <Text>Arbitration Interviews</Text>
        </HStack>
      </HeadingMedium>

      {/*   <Box mb={4}>
            <strong>ML | UNPLUGGED – Arbitration Interviews</strong> ist der
            Podcast von <strong>MANGAL LEGAL</strong>, Ihrer Kanzlei für
            internationale Wirtschaftsstreitigkeiten.
          </Box> */}
      <SimpleGrid
        alignItems={"flex-start"}
        spacing={6}
        templateColumns={{ base: "1fr", md: "0.8fr 0.4fr" }}
      >
        <Box>
          Mit unserem Podcast "Arbitration Interviews" möchten wir Stimmen aus
          der Arbitration-Community zusammenführen – von erfahrenen
          Schiedsrichterinnen und Schiedsrichtern bis hin zu
          Nachwuchsjuristinnen und -juristen. In offenen Gesprächen beleuchten
          wir persönliche Werdegänge, teilen Praxiserfahrungen und rücken die
          Menschen hinter den Schiedsverfahren in den Mittelpunkt. Zugleich
          geben wir Einblicke in aktuelle Entwicklungen, Herausforderungen und
          Perspektiven der Schiedsgerichtsbarkeit – fachlich fundiert,
          authentisch und nah an der Praxis.
          <Divider mb={4} mt={4} w="95%" />
          <Text fontSize="sm" color="gray.800">
            {/*           ML | UNPLUGGED – Arbitration Interviews ist das Gesprächsformat von
            MANGAL LEGAL für alle, die sich für Schiedsverfahren in
            internationalen Wirtschaftsstreitigkeiten interessieren.
            <br />
            <br /> */}
            <Box mb={2} fontWeight="bold">
              An wen richtet sich ML | UNPLUGGED?
            </Box>
            <UnorderedList>
              <ListItem>
                Rechtsanwältinnen und Rechtsanwälte, die Einblicke aus erster
                Hand in die Praxis internationaler Schiedsverfahren schätzen.
              </ListItem>
              <ListItem>
                Unternehmen und Inhouse-Counsel, die Orientierung bei der
                Auswahl geeigneter Schiedsrichter:innen gewinnen möchten.
              </ListItem>

              <ListItem>
                Studierende und Nachwuchsjurist:innen , die den Einstieg in die
                Arbitration-Praxis suchen.
              </ListItem>
              <ListItem>
                Schiedsrichter:innen und Mediator:innen, die sich über aktuelle
                Entwicklungen und unterschiedliche Perspektiven austauschen
                möchten.
              </ListItem>
            </UnorderedList>
          </Text>
        </Box>
        <Box>
          <VStack spacing={8} alignItems="flex-start">
            <HStack
              alignItems={"flex-start"}
              p={4}
              bg="gray.100"
              borderRadius="md"
              spacing={4}
            >
              <Avatar name="Dr. Wajma Mangal" src={WajmaMangalImage} />

              <Text>
                Gastgeberin:
                <br />
                <strong>
                  <Link to={`/${currentLanguage}/team/dr-wajma-mangal`}>
                    Dr. Wajma Mangal
                  </Link>
                </strong>
                <br />
                <Divider my={2} />
                <Text fontSize={"sm"}>
                  Rechtsanwältin und Schiedsrichterin aus Hamburg.
                </Text>
              </Text>
            </HStack>
            <Popover>
              <PopoverTrigger>
                <Button
                  /*  as="a"
                  href="https://open.spotify.com/show/5nUu3gR1b0f6y1bX1Z8Y6D" 
                  target="_blank"*/
                  variant="solid"
                  size="md"
                  textDecoration={"none"}
                >
                  <Box mr="2">
                    <FaSpotify />
                  </Box>{" "}
                  Jetzt reinhören!
                </Button>
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>Bald verfügbar!</PopoverHeader>
                {/*  <PopoverBody>
                      Wir erarbeiten gerade die Inhalte. Bleiben Sie dran!
                    </PopoverBody> */}
              </PopoverContent>
            </Popover>

            <VStack spacing={3} alignItems="flex-start">
              <Text fontSize={"sm"}>
                Sie möchten als Gast teilnehmen oder eine Person empfehlen?
              </Text>

              <Button
                as="a"
                target="_blank"
                variant="solid"
                size="sm"
                textDecoration={"none"}
              >
                <Link
                  to={`/${currentLanguage}/contact`}
                  style={{ textDecoration: "none" }}
                >
                  Kontakt aufnehmen!
                </Link>
              </Button>
            </VStack>
          </VStack>
        </Box>
      </SimpleGrid>
    </MaxWidthContainer>
  );
}
